import type { NotificationPrefs } from '@/types/notifications';

export const NOTIFICATIONS_PATH = '/customer/notifications';
export const NOTIFICATION_SETTINGS_PATH = '/customer/settings/notifications';

/** Everything on except email, as in the design (N4); claim updates can't be turned off. */
export const DEFAULT_NOTIFICATION_PREFS: NotificationPrefs = {
  topics: { claims: true, delivery: true, returns: true, protection: true, plans: true },
  channels: { sms: true, whatsapp: true, email: false },
};
